export const NAV_HOME = '/';

export const NAV_IMPRINT = '/imprint';

export const NAV_LINKEDIN = 'https://www.linkedin.com/company/journexx';

export const NAV_NOT_FOUND = '/not-found';

export const NAV_PRIVACY = '/privacy';

export const NAV_TERMS_CONDITIONS = '/terms-and-conditions';

export const NAV_TWITTER = 'https://twitter.com/JournexxGlobal';
